export default ({ route }) => {
  if (!route || route.fullPath === '/' || route.fullPath.startsWith('/printable/')) return;
  window.localStorage.setItem('lastVisitedPage', route.fullPath);
};
